import { InternalMessageBusChannels } from "sb-internal-msg-bus";
export class ToggleTabEvent {
    constructor(messageBus, blockId) {
        this.messageBus = messageBus;
        this.blockId = blockId;
    }
    emit(elements, parentBlockId) {
        this.messageBus.emit(InternalMessageBusChannels.legacy.tabSwitcher.showHideTab, !(elements.length > 0), parentBlockId, this.blockId);
    }
}
//# sourceMappingURL=ToggleTabEvent.js.map